import { twMerge } from 'tailwind-merge';

import { Pill } from 'components/Pill/Pill';

export type UpgradePlanPillProps = {
  className?: string;
};

export function UpgradePlanPill({ className }: UpgradePlanPillProps) {
  return (
    <Pill
      className={twMerge(
        'whitespace-nowrap border border-[hsl(var(--border)/55%)] bg-[hsl(var(--control-bgActive)/92%)] text-[0.6875rem] text-[hsl(var(--text-highContrast))] shadow-[0_1px_3px_hsl(var(--ui-shadow)/12%)]',
        className
      )}
      intent="warning"
      size="small"
    >
      Upgrade
    </Pill>
  );
}
